export interface Depreciation {
  id?: number;
  status: DepreciationStatus,
  firstStep: FirstStep;
  secondStep: SecondStep;
  thirdStep: ThirdStep;
  skipEventsStep: SkipEventsStep;
  fourthStep: FourthStep;
  fifthStep: FifthStep;
  currentStep: Step;
}

export interface FirstStep {
  title: string;
  status: FirstStepStatus;
  history: History;
  period?: {
    from: string;
    to: string;
  } | null;
  error: string;
  socket?: {
    percentage: number;
    status: string;
  } | null;
}

export interface SecondStep {
  title: string;
  status: SecondStepStatus;
  file?: File | string | null;
  error?: {
    errorMessage: any;
    rowsWithProblems: any;
  } | null;
}

export interface ThirdStep {
  title: string;
  status: ThirdStepStatus;
  file?: File | string | null;
  error?: {
    errorMessage: any;
    rowsWithProblems: any;
  } | null;
  socket?: {
    percentage: number;
    status: string;
  } | null;
}

export interface SkipEventsStep {
  title: string;
  status: SkipEventsStepStatus;
  tabs: {
    selected: Tab;
    registered: SkipEvents;
    unregistered: SkipEvents;
    skipped: SkipEvents;
  }
}

export interface FourthStep {
  title: string;
  status: FourthStepStatus;
  tabs: {
    selected: Tab;
    registered: {
      toolsErrors: ToolsErrors,
      page: number;
      filterBy: FilterBy;
      toolError: Tool | null;
      error: string | null;
    },
    unregistered: {
      toolsErrors: ToolsErrors;
      page: number;
      filterBy: FilterBy;
      toolError: Tool | null;
      error: string | null;
    }
  }
}

export interface FilterBy {
  typeSearch: string,
  search: string,
  typeError: string
}

export interface ToolsErrors {
  tools: Tool[] | [];
  totalMustBeResolved: number;
  totalReprocessableErrors: number;
  length: number;
}

export interface SkipEvents {
  events: {
    tools: SkipEvent[] | [];
    length: number;
  };
  paginator: {
    page: number,
    limit: number
  },
  by: {
    filter: any,
    search: string,
  },
  error: any
}

export interface SkipEvent {
  id: number;
  country: string;
  storeId: number;
  centerCost: string;
  received: string;
  itemId: number;
  itemInstanceId: number;
  quantity: number;
  purchaseOrder: string;
  name: string;
  sku: string;
  codigoProducto: string;
  codigoVenta: string;
  type: string;
  serialNumber: string;
  status: string;
  errorType: string;
  inventoryLogId: any
  depreciated: string;
  skip: boolean;
  purchaseDate: string;
  buyCost: number | null;
  vidaUtil: number;
}

export interface Tool {
  id: number;
  sku: string;
  storeId: number;
  name: string;
  code: string;
  serial: string;
  action: any; // TO-DO: Enum
  error: {
    type: string;
    description: string;
  };
}

export interface FifthStep {
  title: string;
  status: FifthStepStatus;
  files: File[] | string[];
  error?: {
    errorMessage: string;
  } | null;
}

export enum FirstStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  PICKER = 'PICKER',
  CONFIRM = 'CONFIRM',
  SCHEDULED = 'SCHEDULED',
  SOCKET = 'SOCKET',
  CANCEL = 'CANCEL',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export interface Process {
  startDate: string;
  endDate: string;
  user: string;
}

export interface History extends Array<Process>{ }

export enum SecondStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  FILED = 'FILED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export enum ThirdStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  FILED = 'FILED',
  SOCKET = 'SOCKET',
  CANCEL = 'CANCEL',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export enum SkipEventsStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  FILED = 'FILED',
  ONGOING = 'ONGOING',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export enum FourthStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  ONGOING = 'ONGOING',
  CORRECT = 'CORRECT',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export enum FifthStepStatus {
  UNTRIGGERED = 'UNTRIGGERED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED'
}

export enum Step {
  ONE = 0,
  TWO = 1,
  THREE = 2,
  SKIP_EVENTS = 3,
  FOUR = 4,
  FIVE = 5,
}

export enum DepreciationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CANCEL = 'CANCEL',
  ERROR = 'FINISH_ERROR',
  FINISHED = 'FINISH'
}

export enum Tab {
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED',
  SKIPPED = 'SKIPPED'
}

export interface GenericConfirmDialogData {
  title: string;
  info?: string;
  confirm: string;
  cancel: string;
}
